import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stride-listings',
  templateUrl: './stride-listings.component.html',
  styleUrls: ['./stride-listings.component.css']
})
export class StrideListingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
